import React from 'react';
import { ArrowLeft, UserCog, FolderKanban, ClipboardList, Users2 } from 'lucide-react';
import Reveal from './Reveal';

const FEATURE_BADGES = [
  { icon: FolderKanban, label: 'ملف مهني متكامل' },
  { icon: ClipboardList, label: 'خطط وتمارين تكتيكية' },
  { icon: Users2, label: 'طاقم عمل متعاون' },
];

export const LandingCoachesBanner = ({ landing, navigate }) => {
  return (
    <section className="relative overflow-hidden bg-[#060f1c] py-16 sm:py-20" data-testid="landing-coaches-banner">
      {/* شبكة تكتيكية زخرفية + توهج دائري */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(45,212,191,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(45,212,191,0.6) 1px, transparent 1px)',
          backgroundSize: '42px 42px',
        }}
      />
      <div className="pointer-events-none absolute -right-24 top-1/2 h-[420px] w-[420px] -translate-y-1/2 rounded-full bg-teal-500/20 blur-[110px]" />
      <div className="pointer-events-none absolute -left-16 bottom-0 h-[260px] w-[260px] rounded-full bg-[#0A192F] blur-3xl" />

      <Reveal className="relative mx-auto max-w-6xl px-5">
        <div className="group relative overflow-hidden rounded-[28px] border border-teal-500/25 bg-gradient-to-br from-white/[0.06] via-white/[0.03] to-transparent p-6 shadow-[0_0_60px_-15px_rgba(13,148,136,0.35)] backdrop-blur-xl sm:p-10 lg:p-12">
          {/* حد متدرج متوهج يظهر عند التحويم */}
          <div className="pointer-events-none absolute inset-0 rounded-[28px] bg-gradient-to-l from-teal-400/0 via-teal-400/0 to-teal-400/0 opacity-0 transition-opacity duration-700 group-hover:opacity-100 group-hover:from-teal-400/10" />

          <div className="relative flex flex-col items-stretch gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex flex-col items-center gap-5 text-center lg:flex-row lg:items-center lg:text-start">
              <span className="relative flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-2xl border border-teal-400/30 bg-teal-500/10 text-teal-300 shadow-[0_0_25px_-5px_rgba(45,212,191,0.6)]">
                <span className="absolute inset-0 rounded-2xl bg-teal-400/10 blur-md" />
                <UserCog className="relative h-8 w-8" />
              </span>

              <div>
                <span className="mb-2 inline-block rounded-full border border-teal-400/25 bg-teal-400/[0.08] px-3 py-1 text-[11px] font-bold tracking-wide text-teal-300">
                  تسيار للمدربين
                </span>
                <h3
                  className="font-display text-2xl font-extrabold leading-tight text-white sm:text-3xl"
                  data-testid="landing-coaches-banner-title"
                >
                  {landing?.coaches_banner_title || 'هل أنت مدرب رياضي؟'}
                </h3>
                <p
                  className="mt-2 max-w-lg text-sm leading-relaxed text-slate-400 sm:text-base"
                  data-testid="landing-coaches-banner-subtitle"
                >
                  {landing?.coaches_banner_subtitle ||
                    'انضم إلى شبكة مدربي تسيار وتواصل مع الأندية والأكاديميات الباحثة عن خبرتك.'}
                </p>

                <div className="mt-5 flex flex-wrap items-center justify-center gap-2 lg:justify-start">
                  {FEATURE_BADGES.map(({ icon: Icon, label }) => (
                    <span
                      key={label}
                      className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 text-xs font-medium text-slate-300"
                    >
                      <Icon className="h-3.5 w-3.5 text-teal-400" />
                      {label}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <button
              onClick={() => navigate('/coaches')}
              className="group/btn relative flex flex-shrink-0 items-center justify-center gap-2 overflow-hidden rounded-full bg-gradient-to-l from-teal-400 to-teal-500 px-8 py-4 text-sm font-bold text-[#04120f] shadow-[0_10px_30px_-8px_rgba(45,212,191,0.55)] transition-transform duration-300 hover:scale-[1.03] hover:shadow-[0_14px_38px_-6px_rgba(45,212,191,0.7)]"
              data-testid="landing-coaches-banner-cta"
            >
              <span className="absolute inset-0 -translate-x-full bg-white/25 transition-transform duration-500 group-hover/btn:translate-x-full" style={{ transform: 'skewX(-20deg)' }} />
              <span className="relative">استعرض المدربين</span>
              <ArrowLeft className="relative h-4 w-4 transition-transform group-hover/btn:-translate-x-1.5" />
            </button>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default LandingCoachesBanner;
